import { Controller } from "@hotwired/stimulus"

// The box to write in. On a computer Enter sends and Shift+Enter starts a new
// line. On a touch screen return starts a new line and the Send button sends:
// a phone has no Shift+Enter, so return sent every post in pieces. A message
// landing while somebody types refreshes the page by morphing; the box keeps
// what is typed, and only lets go once the post is sent.
export default class extends Controller {
  static targets = ["text"]

  connect() {
    this.keep = this.keep.bind(this)
    this.element.addEventListener("turbo:before-morph-element", this.keep)
  }

  disconnect() {
    this.element.removeEventListener("turbo:before-morph-element", this.keep)
  }

  key(event) {
    if (event.key === "Enter" && !event.shiftKey && !event.isComposing && !this.touch()) {
      event.preventDefault()
      if (this.textTarget.value.trim() !== "") this.element.requestSubmit()
    }
  }

  touch() {
    return window.matchMedia("(pointer: coarse)").matches
  }

  // The box empties when the post leaves, not when the answer comes back. A
  // refresh that lands mid-send, the engine saying the post or the page's own
  // recheck, makes Turbo cancel the form request. The post had arrived, but
  // the box kept it, and Frans sent it a second time. 16 October. So the text
  // comes back only when the server answered and refused it. A cancelled
  // request has no answer, so the page asks again a second later: the post
  // shows from the inbox, or, if it never arrived, it is not there.
  static RECHECK_MS = 1000

  sending() {
    this.draft = this.textTarget.value
    this.textTarget.value = ""
  }

  sent(event) {
    if (event.detail.success) return

    if (event.detail.fetchResponse) {
      if (this.textTarget.value === "") this.textTarget.value = this.draft
    } else {
      setTimeout(() => window.Turbo.session.refresh(location.href), this.constructor.RECHECK_MS)
    }
  }

  keep(event) {
    if (event.target === this.textTarget && this.textTarget.value !== "") event.preventDefault()
  }
}
